import React, { FC } from "react";
import FormControlLabel from "@mui/material/FormControlLabel";
import Radio from "@mui/material/Radio";
import { iRadioLabelProps } from "../../../types/formtypes";

const RadioLabel: FC<iRadioLabelProps> = ({
	FormControlLabelValue,
	FormControlLabelLabel,
}) => {
	return (
		<FormControlLabel
			value={FormControlLabelValue}
			control={<Radio />}
			label={FormControlLabelLabel}
		/>
	);
};
export default RadioLabel;
